/**
 * API Configuration
 * Central place to manage backend API URLs
 * 
 * For local development, set REACT_APP_API_URL=http://127.0.0.1:5001 in .env.local
 * For production, leave empty (uses relative paths)
 */

// Detect if running on localhost and use localhost API by default for development
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Backend API base URL - auto-detect localhost for development convenience
export const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (isLocalhost ? 'http://127.0.0.1:5001' : '');

// API Endpoints
export const API_ENDPOINTS = {
  // Plans & Subscriptions
  plans: `${API_BASE_URL}/api/plans`,
  planById: (id) => `${API_BASE_URL}/api/plans/${id}`,
  userPlan: `${API_BASE_URL}/api/user/plan`,
  
  // Marketing Genius
  generateReport: `${API_BASE_URL}/api/marketing-genius/generate-report`,
  
  // Platforms
  platforms: `${API_BASE_URL}/api/platforms`,
  
  // Orders
  orders: `${API_BASE_URL}/api/supabase/orders`,
  createOrder: `${API_BASE_URL}/api/supabase/orders/create`,
  
  // Customers & Vendors
  customers: `${API_BASE_URL}/api/supabase/customers`,
  vendors: `${API_BASE_URL}/api/supabase/vendors`,
  
  // Forecasts
  recommendedBudget: `${API_BASE_URL}/api/get-recommended-budget`,
  marketingForecast: `${API_BASE_URL}/api/get-marketing-forecast`,
  socialRecommendations: `${API_BASE_URL}/api/get-social-recommendations`,
  
  // Contact Form
  contact: `${API_BASE_URL}/api/contact`,
};

export default API_BASE_URL;

